import { computed } from 'vue';
import { useStore } from 'vuex';
import yup from '@component_path/inquiry_form_common_module/customValidation';

export const useAgeField = (required, messages = {}) => {
  const fieldName = computed(() => 'age');
  const validator = yup
    .number()
    .integer()
    .typeError(messages['requirement'] || '生まれ年は必須項目です')
    .requirement(required, messages['requirement'] || '生まれ年は必須項目です');

  return { validator, fieldName };
};

export const useAgeStore = () => {
  const store = useStore();

  const age = computed(() => store.state.formData.age);
  const birthYears = computed(
    () =>
      store.state.masterData.birth_years || store.state.masterData.birthYears
  );
  const birthYear = computed(() =>
    birthYears.value.find(year => year.value === age.value)
  );
  const dispatcher = computed(() => 'formData/setAge');

  return { age, birthYears, birthYear, dispatcher };
};
